import { render } from "./DevelopersCard.vue?vue&type=template&id=359eb974&scoped=true"
import script from "./DevelopersCard.vue?vue&type=script&lang=js"
export * from "./DevelopersCard.vue?vue&type=script&lang=js"

import "./DevelopersCard.vue?vue&type=style&index=0&id=359eb974&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-359eb974"]])

export default __exports__